import React from "react";
import {IonItem, IonLabel} from "@ionic/react";
import {useCustomerStore} from "../../redux/customers";
import "./ReadOnlyBanner.css";

/**
 * Explains, on the home screen, why the account is read-only — the API owns both
 * the flag and the wording, so the app only renders what it is told.
 */
const ReadOnlyBanner: React.FC = () => {
    const {activeCustomer} = useCustomerStore();

    if (!activeCustomer?.accountReadOnly) {
        return null;
    }

    return (
        <IonItem color="warning" lines="none" className="read-only-banner" data-testid="read-only-banner">
            <IonLabel className="ion-text-wrap">
                <p>{activeCustomer.accountReadOnlyReason}</p>
            </IonLabel>
        </IonItem>
    );
};

export default ReadOnlyBanner;
